import { MENU_ITEM_OPTION } from "../Actions/Utilites";

const INITIAL_STATE = {
  // Add Menu Item Option
  MenuItemOptionLoading: false,
  MenuItemOptionSuccess: false,
  MenuItemOptionFailure: false,
  MenuImageError: null,

  // Add Menu Item Option
  updateMenuItemOptionLoading: false,
  updateMenuItemOptionSuccess: false,
  updateMenuItemOptionFailure: false,
  updateMenuItemOptionError: null,
  updateMenuItemOption:null,

  // Get ALl Menu Option
  getAllMenuItemOptionLoading: false,
  getAllMenuItemOptionSuccess: false,
  getAllMenuItemOptionFailure: false,
  getAllMenuItemOptionError: null,
  getAllMenuItemOption: [],

  // Get ALl Menu Option
  getMenuItemOptionLoading: false,
  getMenuItemOptionSuccess: false,
  getMenuItemOptionFailure: false,
  getMenuItemOptionError: null,
  getMenuItemOption: null,

  // Delete Menu Item Option
  deleteMenuItemOptionLoading: false,
  deleteMenuItemOptionSuccess: false,
  deleteMenuItemOptionFailure: false,
  deleteMenuItemOptionError: null,
  deleteMenu: [],


  // Add Menu Item Option
  showMenuItemOption: null,
};



export const MenuItemOptionReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Add Menu Item Option
    case MENU_ITEM_OPTION.ADD_MENU_ITEM_OPTION_REQUEST:
      return {
        ...state,
        MenuItemOptionLoading: true,
        MenuItemOptionSuccess: false,
        MenuImageError: false,
        loginError: null,
      };
    case MENU_ITEM_OPTION.ADD_MENU_ITEM_OPTION_SUCCESS:
      return {
        ...state,
        MenuItemOptionLoading: false,
        MenuItemOptionSuccess: true,
        MenuImageError: false,
        loginError: null,
      };
    case MENU_ITEM_OPTION.ADD_MENU_ITEM_OPTION_FAILURE:
      return {
        ...state,
        MenuItemOptionLoading: false,
        MenuItemOptionSuccess: false,
        MenuImageError: true,
        loginError: action.payload,
      };

    // Update Menu Item Option
    case MENU_ITEM_OPTION.UPDATE_MENU_ITEM_OPTION_REQUEST:
      return {
        ...state,
        updateMenuItemOptionLoading: true,
        updateMenuItemOptionSuccess: false,
        updateMenuItemOptionFailure: false,
        updateMenuItemOptionError: null,
      };
    case MENU_ITEM_OPTION.UPDATE_MENU_ITEM_OPTION_SUCCESS:
      return {
        ...state,
        MenuItemOptionLoading: false,
        MenuItemOptionSuccess: true,
        updateMenuItemOptionFailure: false,
        updateMenuItemOptionError: null,
        updateMenuItemOption: action.payload,
      };
    case MENU_ITEM_OPTION.UPDATE_MENU_ITEM_OPTION_FAILURE:
      return {
        ...state,
        MenuItemOptionLoading: false,
        MenuItemOptionSuccess: false,
        updateMenuItemOptionFailure: true,
        updateMenuItemOptionError: action.payload,
        updateMenuItemOption: null,
      };

    // Get All Menu Item Option
    case MENU_ITEM_OPTION.GET_All_MENU_ITEM_OPTION_REQUEST:
      return {
        ...state,
        getAllMenuItemOptionLoading: true,
        getAllMenuItemOptionSuccess: false,
        getAllMenuItemOptionFailure: false,
        getAllMenuItemOptionError: null,
      };
    case MENU_ITEM_OPTION.GET_All_MENU_ITEM_OPTION_SUCCESS:
      return {
        ...state,
        getAllMenuItemOptionLoading: false,
        getAllMenuItemOptionSuccess: true,
        getAllMenuItemOptionFailure: false,
        addAllMenuError: null,
        getAllMenuItemOption: action.payload.result,
      };
    case MENU_ITEM_OPTION.GET_All_MENU_ITEM_OPTION_FAILURE:
      return {
        ...state,
        getAllMenuItemOptionLoading: false,
        getAllMenuItemOptionSuccess: false,
        getAllMenuItemOptionFailure: true,
        getAllMenuItemOptionError: action.payload,
      };

    // Get ALl
    case MENU_ITEM_OPTION.SET_NULL_All_MENU_ITEM_OPTION_LIST:
      return {
        ...state,
        getAllMenuItemOptionLoading: false,
        getAllMenuItemOptionSuccess: false,
        getAllMenuItemOptionFailure: false,
        addAllMenuError: null,
        getAllMenuItemOption: action.payload,
      };

    // Sigle Menu Item
    case MENU_ITEM_OPTION.GET_MENU_ITEM_OPTION_REQUEST:
      return {
        ...state,
        getMenuItemOptionLoading: true,
        getMenuItemOptionSuccess: false,
        getMenuItemOptionFailure: false,
        getMenuItemOptionError: null,
      };
    case MENU_ITEM_OPTION.GET_MENU_ITEM_OPTION_SUCCESS:
      return {
        ...state,
        getMenuItemOptionLoading: false,
        getMenuItemOptionSuccess: true,
        getMenuItemOptionFailure: false,
        getMenuItemOptionError: null,
        getMenuItemOption: action.payload.result,
      };
    case MENU_ITEM_OPTION.GET_MENU_ITEM_OPTION_FAILURE:
      return {
        ...state,
        getMenuItemOptionLoading: false,
        getMenuItemOptionSuccess: false,
        getMenuItemOptionFailure: true,
        getMenuItemOptionError: action.payload,
      };

    // Set Null Single
    case MENU_ITEM_OPTION.SET_NULL_MENU_ITEM_OPTION:
      return {
        ...state,
        getMenuItemOptionLoading: false,
        getMenuItemOptionSuccess: false,
        getMenuItemOptionFailure: false,
        getMenuItemOptionError: null,
        getMenuItemOption: action.payload,
      };

    // Delete
    case MENU_ITEM_OPTION.DELETE_MENU_ITEM_OPTION_REQUEST:
      return {
        ...state,
        deleteMenuItemOptionLoading: true,
        deleteMenuItemOptionSuccess: false,
        deleteMenuItemOptionFailure: false,
        deleteMenuItemOptionError: null,
      };
    case MENU_ITEM_OPTION.DELETE_MENU_ITEM_OPTION_SUCCESS:
      const result = state.getAllMenuItemOption.filter(
        (item) => item.menuItemOptionId !== action.payload.result
      );
      return {
        ...state,
        deleteMenuItemOptionLoading: false,
        deleteMenuItemOptionSuccess: true,
        deleteMenuItemOptionFailure: false,
        deleteMenuItemOptionError: null,
        getAllMenuItemOption: result,
      };
    case MENU_ITEM_OPTION.DELETE_MENU_ITEM_OPTION_FAILURE:
      return {
        ...state,
        deleteMenuItemOptionLoading: false,
        deleteMenuItemOptionSuccess: false,
        deleteMenuItemOptionFailure: true,
        deleteMenuItemOptionError: action.payload,
      };

    default:
      return state;
  }
};
